import React from "react";
import { Trans } from "react-i18next";
import i18n from "../../../../i18n";

import { mefDate, mefMontant, mefMontantStr } from "../../../../utils/mef";
import { TableCustom } from "../../../Structure/navbar/blueprintTableincludes";
import {
  Button,
  Callout,
  Classes,
  Dialog,
  HTMLTable,
  Icon,
  Tag,
} from "@blueprintjs/core";

export default class PaymentStationsHistory extends React.Component {
  constructor() {
    super();
    this.state = {
      detail: undefined,
    };
  }

  BillSafe(raw) {
    let tt = 0;
    let nb = 0;
    for (const val of raw?.bill_safe || []) {
      tt += val["value_cents"] * val["number"];
      nb += val["number"];
    }
    return (
      <span>
        {mefMontant(tt)} ({nb} <Trans>bills</Trans>)
      </span>
    );
  }

  CoinRecyclers(raw) {
    let tt = 0;
    let nb = 0;
    for (const val of raw?.coin_recyclers || []) {
      tt += val["value_cents"] * val["number"];
      nb += val["number"];
    }
    return (
      <span>
        {mefMontant(tt)} ({nb} <Trans>coins</Trans>)
      </span>
    );
  }

  BillRecyclers(raw) {
    let tt = 0;
    let nb = 0;
    for (const val of raw?.bill_recyclers || []) {
      tt += val["value_cents"] * val["number"];
      nb += val["number"];
    }
    return (
      <span>
        {mefMontant(tt)} ({nb} <Trans>bills</Trans>)
      </span>
    );
  }

  RawTotal(raw) {
    let tt = 0;
    for (const val of [
      ...raw?.coin_reserves,
      ...raw?.bill_recyclers,
      ...raw?.coin_recyclers,
      ...raw?.bill_safe,
    ] || []) {
      tt += val["value_cents"] * val["number"];
    }
    tt += raw.coin_safe_value;
    return tt;
  }

  render() {
    return this.props.urlsearchparams ? (
      <Callout
        icon="bank-account"
        title={<Trans>payment stations states</Trans>}
      >
        <TableCustom
          paging={true}
          url={"/financial/ps/history?" + this.props.urlsearchparams}
          orderBy="date"
          columns={[
            {
              title: <Trans>date</Trans>,
              field: "date",
              sortable: true,
              render: (raw, rawId) => mefDate(raw.date),
            },
            {
              title: <Trans>park</Trans>,
              field: "park",
              render: (raw) => raw?.device?.park?.name || raw?.device?.park?.id,
            },
            {
              title: <Trans>device</Trans>,
              field: "device",
              render: (raw) => raw?.device?.name || raw?.device?.id,
            },
            {
              title: <Trans>activity</Trans>,
              field: "activity",
              render: (raw) => i18n.t("ps_activity_" + raw.activity),
            },
            {
              title: <Trans>coin recyclers</Trans>,
              field: "price",
              render: (raw) => this.CoinRecyclers(raw),
            },
            {
              title: <Trans>coin safe</Trans>,
              field: "price",
              render: (raw) => (
                <span>
                  {mefMontant(raw.coin_safe_value)} ({raw.coin_safe_number}{" "}
                  <Trans>coins</Trans>)
                </span>
              ),
            },
            {
              title: <Trans>bill recycler</Trans>,
              field: "price",
              render: (raw) => this.BillRecyclers(raw),
            },
            {
              title: <Trans>bill safe</Trans>,
              field: "price",
              render: (raw) => this.BillSafe(raw),
            },
            {
              title: "Total",
              field: "activity",
              render: (raw) => mefMontant(this.RawTotal(raw)),
            },
            {
              title: "Delta",
              field: "activity",
              render: (raw) => {
                if (raw?.previous_state) {
                  const delta =
                    this.RawTotal(raw) - this.RawTotal(raw?.previous_state);
                  let icon = "blank";
                  if (delta > 0) icon = "plus";
                  if (delta < 0) icon = "minus";
                  if (delta === 0) return <Icon icon="equals" />;
                  return (
                    <span>
                      <Icon icon={icon} />
                      {mefMontantStr(Math.abs(delta))}
                    </span>
                  );
                } else return null;
              },
              intent: (raw) => {
                if (raw?.previous_state) {
                  const delta =
                    this.RawTotal(raw) - this.RawTotal(raw?.previous_state);
                  if (delta > 0) return "success";
                  if (delta < 0) return "danger";
                  if (delta === 0) return "primary";
                } else return "normal";
              },
            },
            {
              render: (raw) => (
                <Tag
                  minimal={true}
                  icon="small-info-sign"
                  interactive={true}
                  onClick={() => this.setState({ detail: raw })}
                />
              ),
            },
          ]}
        />
        {this.state.detail && (
          <Dialog
            isOpen={this.state.detail != undefined}
            style={{ transition: "none" }}
            onClose={() => this.setState({ detail: undefined })}
            title={
              mefDate(this.state.detail?.date) +
              " - " +
              this.state.detail?.device?.name +
              " - " +
              i18n.t("ps_activity_" + this.state.detail.activity)
            }
          >
            <div className={Classes.DIALOG_BODY}>
              <Callout title={<Trans>Coins</Trans>}>
                <Callout title={<Trans>hoopers</Trans>}>
                  <HTMLTable
                    compact={true}
                    striped={true}
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>
                          <Trans>value</Trans>
                        </th>
                        <th>
                          <Trans>number of coins</Trans>
                        </th>
                        <th>
                          <Trans>amount</Trans>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.detail.coin_reserves.map((l) => (
                        <tr>
                          <td>{mefMontant(l.value_cents)}</td>
                          <td>{l.number}</td>
                          <td>{mefMontant(l.value_cents * l.number)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </HTMLTable>
                </Callout>
                <Callout title={<Trans>recyclers</Trans>}>
                  <HTMLTable
                    compact={true}
                    striped={true}
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>
                          <Trans>value</Trans>
                        </th>
                        <th>
                          <Trans>number of coins</Trans>
                        </th>
                        <th>
                          <Trans>amount</Trans>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.detail.coin_recyclers.map((l) => (
                        <tr>
                          <td>{mefMontant(l.value_cents)}</td>
                          <td>{l.number}</td>
                          <td>{mefMontant(l.value_cents * l.number)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </HTMLTable>
                </Callout>
                <Callout title={<Trans>safe</Trans>}>
                  <HTMLTable
                    compact={true}
                    striped={true}
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>
                          <Trans>number of coins</Trans>
                        </th>
                        <th>
                          <Trans>amount</Trans>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{this.state.detail.coin_safe_number}</td>
                        <td>{mefMontant(this.state.detail.coin_safe_value)}</td>
                      </tr>
                    </tbody>
                  </HTMLTable>
                </Callout>
              </Callout>
              <Callout title={<Trans>Bills</Trans>}>
                <Callout title={<Trans>recyclers</Trans>}>
                  <HTMLTable
                    compact={true}
                    striped={true}
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>
                          <Trans>value</Trans>
                        </th>
                        <th>
                          <Trans>number of bills</Trans>
                        </th>
                        <th>
                          <Trans>amount</Trans>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.detail.bill_recyclers.map((l) => (
                        <tr>
                          <td>{mefMontant(l.value_cents)}</td>
                          <td>{l.number}</td>
                          <td>{mefMontant(l.value_cents * l.number)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </HTMLTable>
                </Callout>
                <Callout title={<Trans>safe</Trans>}>
                  <HTMLTable
                    compact={true}
                    striped={true}
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>
                          <Trans>value</Trans>
                        </th>
                        <th>
                          <Trans>number of bills</Trans>
                        </th>
                        <th>
                          <Trans>amount</Trans>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.detail.bill_safe.map((l) =>
                        l.number ? (
                          <tr>
                            <td>{mefMontant(l.value_cents)}</td>
                            <td>{l.number}</td>
                            <td>{mefMontant(l.value_cents * l.number)}</td>
                          </tr>
                        ) : null
                      )}
                    </tbody>
                  </HTMLTable>
                </Callout>
              </Callout>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button
                  icon="undo"
                  disabled={this.state.loading}
                  onClick={() =>
                    this.setState({
                      runningEdit: false,
                      addEvent: false,
                      addUser: false,
                    })
                  }
                >
                  <Trans>cancel</Trans>
                </Button>
              </div>
            </div>
          </Dialog>
        )}
      </Callout>
    ) : null;
  }
}
